<button mat-raised-button class="w-100" [disabled]="valid" (click)="onClick()" [class]="theme.myButtonBgColor">
        <mat-icon>{{icon}}</mat-icon> {{title}}
</button>